module.exports = __webpack_public_path__ + "img/blue_bay_living_2_302.ef288f38.jpeg";